import Dict from '@/utils/dict-utils'

/**
 * 在线签章状态
 * @type {DictUtil}
 * @property {1} TO_BE_SIGNED 待签章
 * @property {2} SIGNING 签章中
 * @property {3} SIGNED 已签章
 */
export const signatureStatusDict = new Dict({
  INITIAL: { label: '未签章', value: 0, type: 'warning' }, // 这个作为初始状态使用，不是真正的“未签章”状态
  TO_BE_SIGNED: { label: '未签章', value: 1, type: 'warning' },
  SIGNING: { label: '签章中', value: 2, type: 'primary' },
  SIGNED: { label: '已签章', value: 3, type: 'success' },
  BACK: { label: '已撤回', value: 4, type: 'info' },
  REJECTED: { label: '已拒绝', value: 5, type: 'danger' }
})
